import { Link } from "react-router-dom";
import { featuredChannels } from "@/mocks/homeData";

export default function FeaturedChannelsSection() {
  const channelColors: Record<string, { bg: string; text: string; border: string }> = {
    primary: {
      bg: "bg-primary-100/80",
      text: "text-primary-700",
      border: "border-primary-200",
    },
    accent: {
      bg: "bg-accent-100/80",
      text: "text-accent-900",
      border: "border-accent-200",
    },
    secondary: {
      bg: "bg-secondary-100/80",
      text: "text-secondary-900",
      border: "border-secondary-200",
    },
  };

  return (
    <section className="relative py-16 md:py-24 px-4 md:px-8 bg-background-100" aria-label="精选频道">
      <div className="max-w-7xl mx-auto">
        <div className="mb-4">
          <span className="text-xs text-foreground-500 font-medium tracking-wider uppercase">热门入口</span>
        </div>
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-50 mb-14">
          网红黑料 · 明星八卦
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featuredChannels.map((channel) => (
            <Link
              key={channel.id}
              to={`/category/${channel.slug}`}
              className="group bg-background-200/70 rounded-xl p-6 md:p-8 transition-all duration-300 hover:bg-background-200 cursor-pointer border border-background-300/40 hover:border-background-300"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg mb-5 ${channelColors[channel.color]?.bg || "bg-secondary-100"} ${channelColors[channel.color]?.text || "text-secondary-900"}`}>
                <i className={`${channel.icon} text-xl`}></i>
              </div>
              <h3 className={`text-lg font-medium mb-3 ${channelColors[channel.color]?.text || "text-foreground-100"}`}>
                {channel.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {channel.description}
              </p>
              <div className="mt-5 flex items-center gap-1.5 text-xs text-foreground-500 group-hover:text-foreground-300 transition-colors">
                <span>浏览频道</span>
                <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}